/**
 * Функция, которая возвращает ratio
 */
export const getDevicePixelRatio = () => {
  return 'devicePixelRatio' in window ? window.devicePixelRatio : 1;
};
